import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'snakeCaseTitle',
  standalone: true,
})
export class SnakeCaseTitlePipe implements PipeTransform {
  transform(value: string): string {
    let parts = value.split('_');
    parts = parts.map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase());
    return value ? parts.join(' ') : value;
  }
}
